const menuAccessTypes = {
  authenticated: 'authenticated',
  unAuthenticated: 'unAuthenticated',
  both: 'both'
};

export default menuAccessTypes;


// WEBPACK FOOTER //
// ./src/common/constants/menuAccessTypes.js